export default "__VITE_ASSET__43730b17__"